// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2ia_T","buttons":"RemoveExpirationActionButtons_buttons__2a8FB"};